import { render, staticRenderFns } from "./LeaveSummaryReportTableRow.vue?vue&type=template&id=19ff9174"
import script from "./LeaveSummaryReportTableRow.vue?vue&type=script&lang=js"
export * from "./LeaveSummaryReportTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports